module.exports = __webpack_public_path__ + "static/img/grade_4.647c9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_4.png
// module id = p+pI
// module chunks = 89